import * as Yup from 'yup'

export const uploadAvatarSchema = Yup.object({
  file: Yup.mixed().required('Selecione uma imagem para continuar'),
  preview: Yup.string().required('Recorte obrigatório'),
})
